import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function SkeletonGridUniDriver(base: UniDriver, _body: UniDriver) {
  return {
    ...baseUniDriverFactory(base),
    skeletonItemsCount: () =>
      base.$$('[data-hook="skeleton-grid"] > *').count(),
  };
}

export default SkeletonGridUniDriver;
